import Service from '@ember/service';
import { addDays } from 'date-fns/addDays';
import { subDays } from 'date-fns/subDays';
import { CALENDAR_DATES_PER_PAGE } from 'uplisting-frontend/services/calendar/manager';

export interface ICalendarViewport {
  startDate: Date;
  endDate: Date;
  dates: Date[];
  totalDays: number;
}

export interface INavigationDates {
  today: Date;
  previousWeek: Date;
  nextWeek: Date;
  previousRange: Date;
  nextRange: Date;
}

export default class CalendarUtilsService extends Service {
  /**
   * create a calendar viewport with all necessary date information
   */
  public createCalendarViewport(startDate: Date): ICalendarViewport {
    const dates = this.#generateDateRange(startDate, CALENDAR_DATES_PER_PAGE);

    return {
      startDate: dates[0] as Date,
      endDate: dates[dates.length - 1] as Date,
      dates,
      totalDays: CALENDAR_DATES_PER_PAGE,
    };
  }

  /**
   * navigation dates for calendar controls
   */
  public getNavigationDates(currentDate?: Date): INavigationDates {
    const date = currentDate ?? new Date();

    return {
      today: date,
      previousWeek: subDays(date, 7),
      nextWeek: addDays(date, 7),
      previousRange: subDays(date, CALENDAR_DATES_PER_PAGE),
      nextRange: addDays(date, CALENDAR_DATES_PER_PAGE),
    };
  }

  /**
   * generate a range of dates for calendar display
   */
  #generateDateRange(startDate: Date, numberOfDays: number): Date[] {
    const dates: Date[] = [];

    for (let i = 0; i < numberOfDays; i++) {
      dates.push(new Date(startDate));

      startDate = addDays(startDate, 1);
    }

    return dates;
  }
}

declare module '@ember/service' {
  interface Registry {
    'calendar/utils': CalendarUtilsService;
  }
}
